// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const MAX_DELAY_MS = 5 * 60 * 1000;
